import { render, staticRenderFns } from "./LocalLoader.vue?vue&type=template&id=c0d26e76&scoped=true&"
import script from "./LocalLoader.vue?vue&type=script&lang=ts&"
export * from "./LocalLoader.vue?vue&type=script&lang=ts&"
import style0 from "./LocalLoader.vue?vue&type=style&index=0&id=c0d26e76&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0d26e76",
  null
  
)

export default component.exports